import { useMemo } from 'react';

const useToday = (originalToday?: Date) => {
  const today = useMemo(() => originalToday ?? new Date(), [originalToday]);
  return today;
};

export default useToday;
